/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Cover1Inputs */

const vi_cmspost_cover1 = /** @type {(inputs: Cmspost_Cover1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bìa`)
};

/**

* @param {Cmspost_Cover1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_cover1 = /** @type {((inputs?: Cmspost_Cover1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Cover1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_cover1(inputs)
});
export { cmspost_cover1 as "cmsPost_cover" }